export default __webpack_public_path__ + "static/media/team97.0199ac39.JPG";